import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import * as SharedSelectors from './shared.selectors';
import * as SharedActions from './shared.actions';

@Injectable()
export class SharedFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  countryList$ = this.store.pipe(select(SharedSelectors.getCountryList));
  stateList$ = this.store.pipe(select(SharedSelectors.getStatesList));
  planList$ = this.store.pipe(select(SharedSelectors.getPlanList));
  validateEmail$ = this.store.pipe(select(SharedSelectors.getEmailValidation));
  isLoaded$ = this.store.pipe(select(SharedSelectors.getApiLoadingStatus));
  isClearSearch$ = this.store.pipe(select(SharedSelectors.GetClearSearch));
  allGridConfigs$ = this.store.pipe(select(SharedSelectors.GetAllGridConfigs));
  gridState$ = this.store.pipe(select(SharedSelectors.GetGridState));

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */

  getCountryList() {
    this.store.dispatch(SharedActions.getCountry());
  }

  getStatesList(payload: any) {
    this.store.dispatch(SharedActions.getStates({ payload }));
  }

  getPlanList(payload: any) {
    this.store.dispatch(SharedActions.getPlan(payload));
  }

  setPlanListFromCache(cachedPlans: any[]) {
    this.store.dispatch(SharedActions.setPlanListFromCache({ planList: cachedPlans }));
  }

  clearPlanList() {
    this.store.dispatch(SharedActions.clearPlanList());
  }
  checkEmailValidation(payload: any) {
    this.store.dispatch(SharedActions.isEmailExist({ payload }));
  }

  clearEmailValidation() {
    this.store.dispatch(SharedActions.clearEmailVal());
  }

  hideShowLoader(isLoaded = true) {
    this.store.dispatch(SharedActions.hideShowLoader({ isLoaded }));
  }

  errorToaster(description: any) {
    this.store.dispatch(SharedActions.ToasterError({ description: description }));
  }

  successToaster(description: any) {
    this.store.dispatch(SharedActions.ToasterSuccess({ description: description }));
  }

  warningToaster(description: any) {
    this.store.dispatch(SharedActions.ToasterWarning({ description: description }));
  }

  clearSearch(isClearSearch: any) {
    this.store.dispatch(SharedActions.clearSearchFilter({ isClearSearch: isClearSearch }));
  }

  getGridConfigs() {
    this.store.dispatch(SharedActions.getAllGridConfig());
  }

  setGridState(gridState: any) {
    this.store.dispatch(SharedActions.setGridCofiguration({ gridState }));
  }

  updateGridState(payload: any) {
    this.store.dispatch(SharedActions.updateGridCofiguration({ payload }));
  }
}
